import {sanityClient} from "./sanity";
import imageUrlBuilder from "@sanity/image-url";
const sanityImageBuilder = imageUrlBuilder(sanityClient);

export default sanityImageBuilder;
